(function () {
  const SEL_ROOT =
    '[data-collection-product-slider], [data-product-recommendations-slider], [data-recently-viewed-slider]';
  const SEL_SWIPER = '.collection-product-slider__swiper';

  /**
   * @param {HTMLElement} root
   */
  function destroySwiper(root) {
    const el = root.querySelector(SEL_SWIPER);
    if (!el) return;
    const prev = el._collectionProductSwiper;
    if (prev && typeof prev.destroy === 'function') {
      try {
        prev.destroy(true, true);
      } catch (_) {}
      el._collectionProductSwiper = null;
    }
  }

  /**
   * Initialize Swiper for a collection or product-recommendations slider root.
   * Exposed for lazy-loaded recommendation HTML.
   * @param {HTMLElement} root
   */
  function initCollectionProductSlider(root) {
    if (!root || !root.querySelector) return;

    const swiperEl = root.querySelector(SEL_SWIPER);
    if (!swiperEl || typeof window.Swiper !== 'function') return;

    destroySwiper(root);

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const count = slides.length;
    if (count === 0) return;

    const prevEl = root.querySelector('[data-cps-prev]');
    const nextEl = root.querySelector('[data-cps-next]');

    const opts = {
      // `rewind`, not `loop`. With `slidesPerView: 'auto'` this Swiper build
      // breaks under loop mode: slideNext() advances exactly once and then
      // returns false forever, while isEnd stays false and snap points remain
      // ahead of the current translate. Every arrow in the theme was dead
      // because of it. Measured on 2026-09-23 against a slider of 7 slides,
      // 352px each in a 1439px frame: loop gave 0,1,1,1,1 — rewind gives
      // 0,1,2,3,0, which is what loop was meant to feel like anyway.
      rewind: count > 1,
      slidesPerView: 'auto',
      spaceBetween: 10,
      // The first product started at 0 while the heading, the Shop now button
      // and the arrows above it all sit at the header's 28px gutter, so on a
      // phone the card's title ran off the left edge. This offsets the track's
      // start instead of padding the swiper, which would have changed every
      // slide's width — with slidesPerView: 'auto' the widths come from the
      // slides themselves and are worth leaving alone.
      //
      // Mobile only, as asked. Above 1024px the header centres inside a
      // max-width and no longer lines up with the track's edge, so desktop
      // keeps its existing 0.
      slidesOffsetBefore: 28,
      breakpoints: {
        1024: { slidesOffsetBefore: 0 },
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
    };

    if (prevEl && nextEl) {
      opts.navigation = { prevEl, nextEl };
    }

    swiperEl._collectionProductSwiper = new window.Swiper(swiperEl, opts);
  }

  window.wfInitCollectionProductSwiper = initCollectionProductSlider;

  function initAll() {
    document.querySelectorAll(SEL_ROOT).forEach(initCollectionProductSlider);
  }

  function onResize() {
    document.querySelectorAll(SEL_ROOT).forEach(initCollectionProductSlider);
  }

  let resizeTimer;
  function debouncedResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onResize, 150);
  }

  if (!window.__wfCollectionProductSliderListeners) {
    window.__wfCollectionProductSliderListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('resize', debouncedResize);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target || !event.target.querySelectorAll) return;
      event.target.querySelectorAll(SEL_ROOT).forEach(initCollectionProductSlider);
    });

    document.addEventListener('balance:gender-change', function () {
      requestAnimationFrame(function () {
        document.querySelectorAll(SEL_ROOT).forEach(function (root) {
          const el = root.querySelector(SEL_SWIPER);
          if (el && el._collectionProductSwiper) {
            try {
              el._collectionProductSwiper.update();
            } catch (_) {}
          } else {
            initCollectionProductSlider(root);
          }
        });
      });
    });
  } else {
    initAll();
  }
})();
